export class DocumentCategoryRequiredError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, DocumentCategoryRequiredError.prototype);
  }
}
